import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=a1a4b16e&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=a1a4b16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a4b16e",
  null
  
)

export default component.exports